import { render, staticRenderFns } from "./GuardarCasos.vue?vue&type=template&id=705477e5&"
import script from "./GuardarCasos.vue?vue&type=script&lang=js&"
export * from "./GuardarCasos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports